// Auto generated file, do not manually modify!
// com.hotpads.rentpayment.handler.web.v1.RentCreditReportUnenrollRenterFromCreditTrackingHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import { RentCreditReportUnenrollRenterFromCreditTrackingHandler_unenrollRenterFromCreditTracking } from '@zg-rentals/ts-rent-payment-client';

export type RentCreditReportUnenrollRenterFromCreditTrackingHandler_unenrollRenterFromCreditTracking_Options =
  UseMutationOptions<void, unknown, void>;

/**
 * Unenroll renter from credit tracking
 */
export const useRentCreditReportUnenrollRenterFromCreditTrackingHandler_unenrollRenterFromCreditTracking = ({
  httpClient,
  ...options
}: Omit<
  RentCreditReportUnenrollRenterFromCreditTrackingHandler_unenrollRenterFromCreditTracking_Options,
  'mutationFn'
> & { httpClient?: Client } = {}) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: () =>
      RentCreditReportUnenrollRenterFromCreditTrackingHandler_unenrollRenterFromCreditTracking(httpClient),
  });
};
